export const TITLE = "Crop image";

export const ICON_PROPS = {
  icon: "close",
};
